<template>
  <div>
    <div class="hd">
      <h1 class="cap">
      </h1>
    </div>
    <h3 class="cap3">{{ name }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less" scoped></style>
